import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    subscription: {},
};

const subscriptionSlice = createSlice({ 
    name: 'subscription',
    initialState,
    reducers: {
        setSubscription: (state, action) => {
            const data = action.payload
            state.subscription = {noOfTeams: data.noOfTeams, info: data.info, teams: data.teams}
        }, 

        clearSubscription: (state) => {
            state.subscription = {}
        }
     }
})

export const { 
    setSubscription,
    clearSubscription
} = subscriptionSlice.actions

export const getSubscription = (state) => state.subscription.subscription;

export default subscriptionSlice.reducer;